import HubLocationTool from './HubLocationTool';
export default HubLocationTool;
